import { useQuery } from '@tanstack/react-query';
import ApiConfig from 'src/config/api-config';

export interface NoteData {
  id: string;
  title: string;
  description: string;
  date: string;
  pinned: boolean;
  pin_time: string | null;
}

export interface GetClientNotesResponse {
  status: string;
  data: NoteData[];
}

const getClientNotes = async (
  clientId: string,
  sortBy: string,
  search: string,
): Promise<NoteData[]> => {
  if (!clientId) {
    throw new Error('clientId is required');
  }

  const queryParams = new URLSearchParams({
    clientId,
    sort_by: sortBy,
    search: search,
  });

  const apiUrl = `${ApiConfig.CLOUD_FUNCTIONS_BASE_URL}${ApiConfig.TRAINER_GET_CLIENT_NOTES}?${queryParams.toString()}`;

  const response = await fetch(apiUrl, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  });

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    throw new Error(errorData.error || 'Failed to fetch notes');
  }

  const res: GetClientNotesResponse = await response.json();
  return res.data;
};

export const useGetClientNotes = (
  clientId: string,
  sortBy: string = 'newest',
  search: string = '',
) => {
  return useQuery({
    queryKey: ['clientNotes', clientId, sortBy, search],
    queryFn: () => getClientNotes(clientId, sortBy, search),
    enabled: !!clientId,
    staleTime: 0,
    gcTime: 0,
  });
};
